(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relaxim-portal"]) return;
  try {
    
(() => {
  let cleanup = () => {};
  function initPortal() {
    cleanup();
    const gate = document.getElementById('rlx-age-portal');
    const shell = document.getElementById('rlx-store-shell');
    if (!gate || !shell) return;
    const accept = gate.querySelector('[data-age-accept]');
    const decline = gate.querySelector('[data-age-decline]');
    const denied = gate.querySelector('[data-age-denied]');
    const canvas = gate.querySelector('canvas');
    const storageKey = 'relaxim_age_verified_v1';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0, timer = 0, opening = false;
    const previousFocus = document.activeElement;
    const previousOverflow = document.documentElement.style.overflow;
    const previousBodyOverflow = document.body.style.overflow;
    function stopParticles() {
      cancelAnimationFrame(frame);
      let context;
      try { context = canvas.getContext('2d'); } catch (_) {}
      if (context) context.clearRect(0, 0, canvas.width, canvas.height);
      canvas.width = 1; canvas.height = 1;
    }
    function unlock(restoreFocus) {
      stopParticles();
      if (typeof gate.close === 'function') gate.close(); else gate.removeAttribute('open');
      shell.inert = false;
      shell.removeAttribute('inert');
      document.body.classList.add('rlx-store-ready');
      window.dispatchEvent(new CustomEvent('relaxim:store-ready'));
      document.documentElement.style.overflow = previousOverflow;
      document.body.style.overflow = previousBodyOverflow;
      if (restoreFocus) {
        const target = previousFocus && previousFocus !== document.body && shell.contains(previousFocus) ? previousFocus : document.getElementById('MainContent');
        if (target) target.focus({ preventScroll: true });
      }
    }
    function burst() {
      let ctx;
      try { ctx = canvas.getContext('2d'); } catch (_) { return; }
      if (!ctx) return;
      const w = window.innerWidth, h = window.innerHeight;
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      ctx.scale(dpr, dpr);
      const box = accept.getBoundingClientRect();
      const cx = box.left + box.width / 2, cy = box.top + box.height / 2;
      const count = w < 750 ? 42 : 72;
      const particles = Array.from({ length: count }, (_, i) => ({ angle: Math.PI * 2 * i / count + Math.random() * .14, distance: Math.min(w, h) * (.3 + Math.random() * .65), radius: .8 + Math.random() * 2.4 }));
      const start = performance.now();
      function draw(now) {
        const elapsed = Math.min((now - start) / 1000, 1);
        ctx.clearRect(0, 0, w, h);
        const ease = 1 - Math.pow(1 - elapsed, 3);
        ctx.globalAlpha = Math.pow(1 - elapsed, 1.2);
        ctx.strokeStyle = '#b7ffa2'; ctx.lineWidth = 1.5;
        ctx.beginPath(); ctx.arc(cx, cy, 20 + ease * Math.max(w, h), 0, Math.PI * 2); ctx.stroke();
        particles.forEach(p => { ctx.fillStyle = '#bcffa4'; ctx.beginPath(); ctx.arc(cx + Math.cos(p.angle) * p.distance * ease, cy + Math.sin(p.angle) * p.distance * ease, p.radius * (1 - elapsed * .5), 0, Math.PI * 2); ctx.fill(); });
        if (elapsed < 1) frame = requestAnimationFrame(draw);
      }
      frame = requestAnimationFrame(draw);
    }
    function confirm() {
      if (opening) return;
      opening = true;
      accept.disabled = true; decline.disabled = true;
      try { sessionStorage.setItem(storageKey, 'true'); } catch (_) {}
      gate.classList.add('is-opening');
      if (motion.matches) gate.classList.add('is-reduced'); else burst();
      timer = window.setTimeout(() => unlock(true), motion.matches ? 120 : 1000);
    }
    function reject() { denied.hidden = false; denied.querySelector('a').focus(); }
    function cancel(event) { event.preventDefault(); }
    function trap(event) {
      if (event.key === 'Escape') { event.preventDefault(); return; }
      if (event.key !== 'Tab') return;
      const items = [...gate.querySelectorAll('button:not(:disabled), a[href]')].filter(el => !el.closest('[hidden]'));
      if (!items.length) { event.preventDefault(); return; }
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !gate.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    cleanup = () => {
      clearTimeout(timer); stopParticles();
      accept.removeEventListener('click', confirm); decline.removeEventListener('click', reject);
      gate.removeEventListener('cancel', cancel); gate.removeEventListener('keydown', trap);
      document.documentElement.style.overflow = previousOverflow; document.body.style.overflow = previousBodyOverflow;
    };
    let verified = false;
    try { verified = sessionStorage.getItem(storageKey) === 'true'; } catch (_) {}
    if (verified) { unlock(false); return; }
    shell.inert = true;
    document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    if (typeof gate.showModal === 'function') { gate.close(); gate.showModal(); }
    accept.disabled = false; decline.disabled = false;
    accept.addEventListener('click', confirm); decline.addEventListener('click', reject);
    gate.addEventListener('cancel', cancel); gate.addEventListener('keydown', trap);
    accept.focus({ preventScroll: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPortal, { once: true }); else initPortal();
  document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('#rlx-age-portal')) initPortal(); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('#rlx-age-portal')) cleanup(); });
  window.addEventListener('pagehide', () => cleanup());
  window.addEventListener('pageshow', event => { if (event.persisted) initPortal(); });
})();

  } catch(e) { console.error(e); }
})();
})();
